import { logDecodingError } from "../../helpers/airbrake"
import { isTextOverflowed } from "../../helpers/toggle_content"

const CRITERION_SCORE_ATTR = "data-criterion-score"

const setTransformStyle = (target : Element) : void => {
  const score = target.getAttribute(CRITERION_SCORE_ATTR)
  if (!score) return

  (target as HTMLElement).style.transform =
    `translateX(${parseFloat(score) * 10 - 100}%)`
}

const animateReviewsCriteria = () : void => {
  const items = [...document.querySelectorAll(`[${CRITERION_SCORE_ATTR}]`)]

  const observer = new window.IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          setTransformStyle(entry.target)
          observer.unobserve(entry.target)
        }
      })
    }
  )

  items.forEach(item => observer.observe(item))
}

export default (elmVenue: ElmVenue): void => {
  const node = document.getElementById("elm-reviews")
  if (!node) return

  const flags = JSON.parse(node.dataset.elmFlags || "{}")
  const app = elmVenue.Reviews.init({ node, flags })

  app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
  app.ports.visibleReviewsChanged.subscribe((tabPanelId: string) => {
    window.requestAnimationFrame(() => {
      const textOverflowStates = [
        ...document.querySelectorAll(`#${tabPanelId} [itemprop="review"]`)
      ].reduce<[string, boolean][]>((acc, review) => {
        const content = review.querySelector("[data-collapsible]")

        return content
          ? [...acc, [review.id, isTextOverflowed(content as HTMLElement)]]
          : acc
      }, [])

      app.ports.textOverflowChanged.send(textOverflowStates)
    })
  })
  animateReviewsCriteria()
}
